export const medias = {
	minWidth340px: '(min-width: 340px)',
	minWidth558px: '(min-width: 558px)',
	minWidth800px: '(min-width: 800px)',
	minWidth992px: '(min-width: 992px)',
};
